$(document).ready(function() {
    $('.stories-modal__products').on("touchmove", function (e) {
        e.preventDefault()
        return false
    });


    var $video = $('.vjs-tech');

    function playSecondVideo() {
        let parent = $(this).closest(".stories-modal__video")
        let second = parent.find(".stories-modal__video-background")
        second.get(0).play();

        parent.find(".stories-modal__video-play-icon").css('display', 'none')
        if ($( document ).width() <= 992) {
            $('.stories-modal__products-inner').slick('refresh');
        }
    }
    function pauseSecondVideo() {
        let parent = $(this).closest(".stories-modal__video")
        let second = parent.find(".stories-modal__video-background")
        second.get(0).pause();

        parent.find(".stories-modal__video-play-icon").css('display', 'block')
    }
    function timeUpdate() {
        let parent = $(this).closest(".stories-modal__video")
        let second = parent.find(".stories-modal__video-background")
        var currentTime = $(this).get(0).currentTime;
        second.get(0).currentTime = currentTime;
    }

    $video.on('play', playSecondVideo);
    $video.on('pause', pauseSecondVideo);
    $video.on('timeupdate', timeUpdate) 
    
    $video.on('touchstart', function (e) {
        console.log($(this).get(0))
        if (e.target.nodeName === 'VIDEO') {
            if ($(this).get(0).paused) {
                this.play();
            } else {
                this.pause();
            }
        }
    });

    $(".stories-modal__products-inner").slick({
        slidesToShow: 1.6,
        draggable: true,
        dots: false,
        arrows: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 100000,
                settings: "unslick"
            },
            {
                breakpoint: 992,
                settings: {
                    variableWidth: true,
                    slidesToShow: 1.6,
                    slidesToScroll: 1
                }
            }
        ]
    })
    if ($( document ).width() <= 992) {
        setTimeout(() => { $('.stories-modal__products-inner').slick('refresh'); }, 1000);
    }
});

